var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import DataTable from '@/components/data-table/DataTable';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { Setting } from '@/models/Setting';
import Hours from '@/components/hours/Hours';
import { formatDate as format } from '@/support/String';
import client from '@/support/Client';
import { RolesEnum } from '@/items/Roles';
let RosterSettings = class RosterSettings extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = 'tab-opening-hours';
        this.openingHours = [];
        this.editing = {};
        this.settings = [];
        this.editingWeekStart = false;
        this.selectedWeekStart = null;
        this.selectedPlannerStartDay = null;
        this.selectedPlannerStartTime = null;
        this.plannerStartTimeModal = '';
        this.editingPlannerStart = false;
        this.editingSoftLock = false;
        this.editingHardLock = false;
        this.editingVisibleTeacher = false;
        this.editingVisibleStudent = false;
        this.selectedPlannerDate = null;
        this.selectedPlannerTime = null;
        this.startPreRunner = false;
        this.startDatePreRunPlanner = '';
        this.endPreRunner = false;
        this.endDatePreRunPlanner = '';
        this.startPrePlanner = false;
        this.startDatePrePlanner = '';
        this.endPrePlanner = false;
        this.endDatePrePlanner = '';
        this.startAutoPlanner = false;
        this.startDateAutoPlanner = '';
        this.endAutoPlanner = false;
        this.endDateAutoPlanner = '';
        this.isRunningPreRunner = false;
        this.isRunningPrePlanner = false;
        this.isRunningAutoPlanner = false;
        this.autoPlannerWeekIntervalItems = [
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
            { label: '4', value: 4 },
            { label: '5', value: 5 },
            { label: '6', value: 6 },
            { label: '7', value: 7 },
            { label: '8', value: 8 },
            { label: '9', value: 9 },
            { label: '10', value: 10 },
            { label: '11', value: 11 },
            { label: '12', value: 12 },
            { label: '13', value: 13 },
            { label: '14', value: 14 },
            { label: '15', value: 15 },
        ];
        this.weekSettings = {
            release_teacher: {
                editing: false,
                time: '13:00',
                day: 'monday',
                selectedDay: null,
                selectedTime: '00:00',
                modal: false,
            },
            release_student: {
                editing: false,
                time: '15:00',
                day: 'thursday',
                selectedDay: null,
                selectedTime: '00:00',
                modal: false,
            },
            block_roster: {
                editing: false,
                time: '18:00',
                day: 'sunday',
                selectedDay: null,
                selectedTime: '00:00',
                modal: false,
            },
            final_roster: {
                editing: false,
                time: '00:00',
                day: 'monday',
                selectedDay: null,
                selectedTime: '00:00',
                modal: false,
            },
            autoplanner: {
                editing: false,
                time: '00:00',
                day: 'monday',
                selectedDay: null,
                selectedTime: null,
                modal: false,
            },
        };
        this.generalSettings = {
            weekstart: {
                editing: false,
                value: null,
                selected: '',
                modal: false,
            },
            soft_lock_date: {
                editing: false,
                value: '',
                selected: '',
                modal: false,
            },
            hard_lock_date: {
                editing: false,
                value: '',
                selected: '',
                modal: false,
            },
            visibility_date_teachers: {
                editing: false,
                value: '',
                selected: '',
                modal: false,
            },
            visibility_date_students: {
                editing: false,
                value: '',
                selected: '',
                modal: false,
            },
            autoplanner_week_interval: {
                editing: false,
                value: '',
                selected: '',
                modal: false,
            },
        };
        this.softLockDate = '';
        this.hardLockDate = '';
        this.visibleTeacherDate = '';
        this.visibleStudentDate = '';
    }
    mounted() {
        this.initialize();
    }
    updateSettings(key, value) {
        new Setting()
            .limit(100)
            .update([{ key, value }])
            .then((settings) => {
            const setting = this.settings.find((setting) => {
                return setting.key === key;
            });
            if (setting) {
                setting.value = value;
            }
            this.editingWeekStart = false;
            this.editingPlannerStart = false;
            if (this.generalSettings[key]) {
                this.generalSettings[key].modal = false;
                this.generalSettings[key].editing = false;
                this.generalSettings[key].selected = value;
                this.generalSettings[key].selected = value;
            }
            this.collectSettings();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    initialize() {
        this.collectSettings();
    }
    collectSettings() {
        const filteredSettings = [
            'first_day_of_week',
            'autoplanner_day',
            'autoplanner_time',
            'soft_lock_date',
            'hard_lock_date',
            'visibility_date_teachers',
            'visibility_date_students',
            'release_teacher_day',
            'release_teacher_time',
            'release_student_day',
            'release_student_time',
            'block_roster_day',
            'block_roster_time',
            'final_roster_day',
            'final_roster_time',
            'autoplanner_week_interval',
        ];
        const settings = this.$store.state.settings.filter((setting) => {
            return filteredSettings.includes(setting.key);
        });
        const softLockDate = settings.find((setting) => setting.key === 'soft_lock_date');
        const hardLockDate = settings.find((setting) => setting.key === 'hard_lock_date');
        const visibleStudentDate = settings.find((setting) => setting.key === 'visibility_date_students');
        const visibleTeacherDate = settings.find((setting) => setting.key === 'visibility_date_teachers');
        const release_teacher_time = settings.find((setting) => setting.key === 'release_teacher_time');
        if (release_teacher_time) {
            this.weekSettings.release_teacher.selectedTime = release_teacher_time.value;
        }
        const release_student_time = settings.find((setting) => setting.key === 'release_student_time');
        if (release_student_time) {
            this.weekSettings.release_student.selectedTime = release_student_time.value;
        }
        const block_roster_time = settings.find((setting) => setting.key === 'block_roster_time');
        if (block_roster_time) {
            this.weekSettings.block_roster.selectedTime = block_roster_time.value;
        }
        const final_roster_time = settings.find((setting) => setting.key === 'final_roster_time');
        if (final_roster_time) {
            this.weekSettings.final_roster.selectedDay = final_roster_time.value;
        }
        this.generalSettings.soft_lock_date.value = softLockDate ? softLockDate.value : '';
        this.generalSettings.soft_lock_date.selected = softLockDate ? softLockDate.value : '';
        this.generalSettings.hard_lock_date.value = hardLockDate ? hardLockDate.value : '';
        this.generalSettings.hard_lock_date.selected = hardLockDate ? hardLockDate.value : '';
        this.generalSettings.visibility_date_students.value = visibleStudentDate ? visibleStudentDate.value : '';
        this.generalSettings.visibility_date_students.selected = visibleStudentDate ? visibleStudentDate.value : '';
        this.generalSettings.visibility_date_teachers.value = visibleTeacherDate ? visibleTeacherDate.value : '';
        this.generalSettings.visibility_date_teachers.selected = visibleTeacherDate ? visibleTeacherDate.value : '';
        this.$set(this, 'settings', settings);
    }
    getSettingValue(key) {
        const setting = this.settings.find((setting) => {
            return setting.key === key;
        });
        if (setting) {
            return setting.value;
        }
        return null;
    }
    parseTime(time) {
        const parts = time.split(':');
        return `${parts[0]}:${parts[1]}`;
    }
    update(openingHour) {
        openingHour
            .update()
            .then(() => {
            this.initialize();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    updateWeekStart() {
        if (!this.selectedWeekStart) {
            return;
        }
        this.updateSettings('first_day_of_week', this.selectedWeekStart.toLowerCase());
    }
    updateWeekSetting(key) {
        if (!this.weekSettings[key].selectedDay || !this.weekSettings[key].selectedTime) {
            return;
        }
        this.updateSettings(`${key}_day`, this.weekSettings[key].selectedDay || '');
        this.updateSettings(`${key}_time`, this.weekSettings[key].selectedTime || '');
        if (this.weekSettings[key]) {
            setTimeout(() => {
                this.weekSettings[key].editing = false;
            }, 400);
        }
    }
    updateGeneralSetting(key) {
        if (!this.generalSettings[key].selected) {
            return;
        }
        this.updateSettings(key, this.generalSettings[key].selected || '');
    }
    getDayById(id) {
        const openingHour = this.openingHours.find((openingHour) => {
            return openingHour.id === id;
        });
        if (!openingHour || !openingHour.id) {
            return null;
        }
        return openingHour.id;
    }
    resetWeekSetting(key) {
        if (!this.weekSettings[key]) {
            return;
        }
        this.weekSettings[key].modal = false;
        this.weekSettings[key].editing = false;
        this.weekSettings[key].selectedDay = null;
        this.weekSettings[key].selectedTime = '00:00';
    }
    resetGeneralSetting(key) {
        if (!this.generalSettings[key]) {
            return;
        }
        this.generalSettings[key].modal = false;
        this.generalSettings[key].editing = false;
        this.generalSettings[key].selected = this.generalSettings[key].value || '';
    }
    formatDay(day) {
        return !day ? '' : this.$t(`weekDays.${day}`).toString().toUpperCase();
    }
    runAutoPlanner(type) {
        const payload = {
            starts_at: '',
            ends_at: '',
            preCheck: false,
            prePlanner: false,
        };
        if (type === 'prerunner') {
            this.isRunningPreRunner = true;
            payload.starts_at = this.startDatePreRunPlanner;
            payload.ends_at = this.endDatePreRunPlanner;
            payload.preCheck = true;
        }
        if (type === 'preplanner') {
            this.isRunningPrePlanner = true;
            payload.starts_at = this.startDatePrePlanner;
            payload.ends_at = this.endDatePrePlanner;
            payload.prePlanner = true;
        }
        if (type === 'autoplanner') {
            this.isRunningAutoPlanner = true;
            payload.starts_at = this.startDateAutoPlanner;
            payload.ends_at = this.endDateAutoPlanner;
        }
        const school = this.$store.state.settings.find((setting) => {
            return setting.key === 'slug';
        });
        if (!school) {
            return;
        }
        const url = `/commands/run-autoplanner?school=${school.value}`;
        client('post', url, payload)
            .then(() => {
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
};
RosterSettings = __decorate([
    Component({
        components: {
            DataTable,
            SelectFilter,
            Hours,
        },
        filters: {
            formatTime(time) {
                if (!time) {
                    return '';
                }
                if (time === '00:00:00') {
                    return '-';
                }
                const parts = time.split(':');
                return `${parts[0]}:${parts[1]}`;
            },
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
        },
    })
], RosterSettings);
export default RosterSettings;
